import { useMemo } from 'react';

import type { GuardianPlayer } from '@/features/guardian/services/get-guardian-players';
import { buildGuardianPlayerLevelDetailData } from '@/features/guardian-player/utils';

export function useGuardianPlayerLevelDetail(player: GuardianPlayer, level: number) {
  const { firstname, id, lastname, progress } = player;

  const data = useMemo(
    () => buildGuardianPlayerLevelDetailData({ firstname, id, lastname, progress }, level),
    [firstname, id, lastname, level, progress],
  );

  return useMemo(
    () => ({
      data,
    }),
    [data],
  );
}
